<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <MenuItemsForm :baseMenuItem="menuItem" :loading="loading" @submit-requested="submitRequested"></MenuItemsForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MenuItemsForm from './MenuItemsForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            menuItem: null,
            loading: true
        }
    },
    components: { MenuItemsForm },
    computed:
    {
        ...mapState('menuItems', ['getMenuItemDetailsOutput']),
    },
    methods: {
        ...mapActions('menuItems', ['getMenuItemDetails']),
        ...mapActions('menuItems', ['putMenuItem']),
        submitRequested(menuItem) {
            this.putMenuItem(menuItem);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'MenuItemsList' });
        }

        this.getMenuItemDetails(this.$route.query.id);
    },
    watch:
    {
        getMenuItemDetailsOutput: function(menuItemOutput)
        {
            if(!menuItemOutput && !menuItemOutput.data)
            {
                router.push({ name: 'MenuItemsList' });
            }
            else
            {
                this.menuItem = menuItemOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>